import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../App';
import api from '../api';
import DataTable from '../components/DataTable';

const DURUM_RENK = { PLANLI:'#1565c0', GERCEKLESTI:'#1b5e20', IPTAL:'#c62828', ERTELENDI:'#e65100' };
const TUR_LIST = ['RUTIN','SIKAYET_UZERINE','YENILEME','DEVIR','DIGER'];

export default function DenetimListesi() {
  const { kullanici } = useContext(AuthContext);
  const navigate = useNavigate();
  const [veriler, setVeriler] = useState([]);
  const [toplam, setToplam] = useState(0);
  const [yukleniyor, setYukleniyor] = useState(false);
  const [modalAcik, setModalAcik] = useState(false);
  const [secili, setSecili] = useState(null);
  const [filtre, setFiltre] = useState({ durum:'', tur:'', q:'' });
  const [form, setForm] = useState({ ruhsat_id:'', denetim_turu:'RUTIN', planlanan_tarih:'', denetleyen_1:'', denetleyen_2:'', aciklama:'' });
  const [ruhsatArama, setRuhsatArama] = useState('');
  const [ruhsatSonuc, setRuhsatSonuc] = useState([]);
  const [personeller, setPersoneller] = useState([]);
  const yazabilir = ['admin','mudur','zabita'].includes(kullanici?.rol);

  useEffect(() => { yukle(); }, [filtre]); // eslint-disable-line
  useEffect(() => { api.get('/tanimlar/kullanicilar').then(r=>setPersoneller(r.data||[])).catch(()=>{}); }, []);

  const yukle = async () => {
    setYukleniyor(true);
    try {
      const p = new URLSearchParams({ ...filtre, limit:200 });
      const r = await api.get(`/denetim?${p}`);
      setVeriler(r.data.veriler||[]); setToplam(r.data.toplam||0);
    } finally { setYukleniyor(false); }
  };

  const ruhsatAra = async () => {
    if (!ruhsatArama) return;
    const r = await api.get(`/ruhsat?q=${ruhsatArama}&limit=10`);
    setRuhsatSonuc(r.data.veriler||[]);
  };

  const kaydet = async (e) => {
    e.preventDefault();
    try {
      await api.post('/denetim', form);
      yukle(); setModalAcik(false); resetForm();
    } catch (err) { alert(err.response?.data?.hata||'Hata'); }
  };

  const sonucKaydet = async (e) => {
    e.preventDefault();
    try {
      await api.put(`/denetim/${secili.id}`, secili);
      yukle(); setSecili(null);
    } catch (err) { alert(err.response?.data?.hata||'Hata'); }
  };

  const resetForm = () => { setForm({ ruhsat_id:'', denetim_turu:'RUTIN', planlanan_tarih:'', denetleyen_1:'', denetleyen_2:'', aciklama:'' }); setRuhsatArama(''); setRuhsatSonuc([]); };
  const fmt = d => d ? new Date(d).toLocaleDateString('tr-TR') : '';

  const columns = [
    { key:'denetim_no', label:'Denetim No', width:'120px', render:v=><strong style={{fontFamily:'monospace',color:'#1a237e'}}>{v}</strong> },
    { key:'planlanan_tarih', label:'Plan Tarihi', width:'100px', render:v=><span style={{fontSize:'12px'}}>{fmt(v)}</span>, exportValue:r=>fmt(r.planlanan_tarih) },
    { key:'gerceklesen_tarih', label:'Gç. Tarihi', width:'100px', render:v=><span style={{fontSize:'12px',color:v?'#1b5e20':'#bbb'}}>{v?fmt(v):'—'}</span>, exportValue:r=>fmt(r.gerceklesen_tarih) },
    { key:'unvan', label:'İşyeri', render:(v,r)=>v?<span style={{fontSize:'12px'}}><strong>{v}</strong> <span style={{color:'#888'}}>({r.rn})</span></span>:<span style={{color:'#999',fontSize:'12px'}}>Genel Denetim</span>, exportValue:r=>r.unvan||'' },
    { key:'denetim_turu', label:'Tür', width:'110px', render:v=><span style={{fontSize:'11px',padding:'2px 8px',borderRadius:'10px',background:'#e8f5e9',color:'#1b5e20'}}>{v?.replace(/_/g,' ')}</span> },
    { key:'denetleyen1_adi', label:'Denetleyen', width:'130px', render:v=><span style={{fontSize:'12px'}}>{v||'—'}</span> },
    { key:'durum', label:'Durum', width:'90px', render:v=><span style={{fontSize:'11px',fontWeight:'700',color:DURUM_RENK[v]||'#555'}}>{v}</span> },
    { key:'yaptirim_gerekli', label:'Yaptırım', width:'80px', render:v=>v?<span style={{color:'#c62828',fontWeight:'700',fontSize:'11px'}}>⚠ GEREKLI</span>:<span style={{color:'#bbb',fontSize:'11px'}}>—</span> },
    { key:'_islem', label:'İşlem', width:'130px', sortable:false, filterable:false,
      render:(_,r)=>(
        <div style={{display:'flex',gap:'4px'}}>
          {yazabilir&&<button className="btn btn-outline btn-xs" onClick={e=>{e.stopPropagation();setSecili({...r});}}>Sonuç Gir</button>}
          {r.ruhsat_id&&<button className="btn btn-secondary btn-xs" onClick={e=>{e.stopPropagation();navigate(`/ruhsat/${r.ruhsat_id}`);}}>Ruhsat</button>}
        </div>
      )
    },
  ];

  return (
    <div>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'20px'}}>
        <div>
          <h2 style={{color:'#1a237e',fontSize:'20px'}}>🔍 Denetim Planı ve Kayıtları</h2>
          <div style={{fontSize:'12px',color:'#888',marginTop:'2px'}}>Dayanak: 3572 s.K. / İşyeri Ruhsat Yönetmeliği Md.30-32 / 6331 s.K.</div>
        </div>
        {yazabilir&&<button className="btn btn-primary" onClick={()=>setModalAcik(true)}>➕ Denetim Planla</button>}
      </div>

      <div className="card">
        <div className="search-bar">
          <input className="search-input" placeholder="🔍 Denetim no, işyeri..." value={filtre.q} onChange={e=>setFiltre({...filtre,q:e.target.value})} />
          <select value={filtre.durum} onChange={e=>setFiltre({...filtre,durum:e.target.value})} style={{padding:'8px 12px',border:'1px solid #ddd',borderRadius:'4px'}}>
            <option value="">Tüm Durumlar</option>
            {Object.keys(DURUM_RENK).map(k=><option key={k} value={k}>{k}</option>)}
          </select>
          <select value={filtre.tur} onChange={e=>setFiltre({...filtre,tur:e.target.value})} style={{padding:'8px 12px',border:'1px solid #ddd',borderRadius:'4px'}}>
            <option value="">Tüm Türler</option>
            {TUR_LIST.map(k=><option key={k} value={k}>{k.replace(/_/g,' ')}</option>)}
          </select>
        </div>
        <div style={{marginBottom:'8px',fontSize:'12px',color:'#666'}}>Toplam: <strong>{toplam}</strong> denetim kaydı</div>
        <DataTable columns={columns} data={veriler} filename="denetimler" pdfTitle="Denetim Planı Kayıtları" loading={yukleniyor} />
      </div>

      {/* Yeni denetim modal */}
      {modalAcik&&(
        <div className="modal-overlay" onClick={e=>e.target===e.currentTarget&&setModalAcik(false)}>
          <div className="modal" style={{maxWidth:'560px'}}>
            <div className="modal-header"><span className="modal-title">Yeni Denetim Planla</span><button className="modal-close" onClick={()=>setModalAcik(false)}>×</button></div>
            <form onSubmit={kaydet}>
              <div className="form-grid">
                <div className="form-group" style={{gridColumn:'1/-1'}}>
                  <label>İlgili İşyeri (varsa)</label>
                  <div style={{display:'flex',gap:'8px'}}>
                    <input value={ruhsatArama} onChange={e=>setRuhsatArama(e.target.value)} placeholder="Ruhsat no veya işyeri adı..." className="search-input" onKeyDown={e=>e.key==='Enter'&&(e.preventDefault(),ruhsatAra())} />
                    <button type="button" className="btn btn-outline" onClick={ruhsatAra}>Ara</button>
                  </div>
                  {ruhsatSonuc.length>0&&(
                    <div style={{border:'1px solid #ddd',borderRadius:'4px',marginTop:'4px',maxHeight:'150px',overflowY:'auto',background:'#fff'}}>
                      {ruhsatSonuc.map(r=>(
                        <div key={r.id} onClick={()=>{setForm(f=>({...f,ruhsat_id:r.id}));setRuhsatArama(`${r.rn} - ${r.unvan}`);setRuhsatSonuc([]);}}
                          style={{padding:'8px 12px',cursor:'pointer',borderBottom:'1px solid #f0f0f0',fontSize:'13px'}}
                          onMouseOver={e=>e.currentTarget.style.background='#f5f5ff'} onMouseOut={e=>e.currentTarget.style.background='#fff'}>
                          <strong>{r.rn}</strong> — {r.unvan}
                        </div>
                      ))}
                    </div>
                  )}
                  {form.ruhsat_id&&<div style={{fontSize:'12px',color:'#1b5e20',marginTop:'4px'}}>✅ Seçildi <button type="button" style={{color:'#c62828',background:'none',border:'none',cursor:'pointer'}} onClick={()=>{setForm(f=>({...f,ruhsat_id:''}));setRuhsatArama('');}}>✕</button></div>}
                </div>
                <div className="form-group">
                  <label>Denetim Türü *</label>
                  <select value={form.denetim_turu} onChange={e=>setForm({...form,denetim_turu:e.target.value})} required>
                    {TUR_LIST.map(k=><option key={k} value={k}>{k.replace(/_/g,' ')}</option>)}
                  </select>
                </div>
                <div className="form-group">
                  <label>Planlanan Tarih</label>
                  <input type="date" value={form.planlanan_tarih} onChange={e=>setForm({...form,planlanan_tarih:e.target.value})} />
                </div>
                <div className="form-group">
                  <label>1. Denetçi</label>
                  <select value={form.denetleyen_1} onChange={e=>setForm({...form,denetleyen_1:e.target.value})}>
                    <option value="">Seçin...</option>
                    {personeller.map(p=><option key={p.id} value={p.id}>{p.ad_soyad} ({p.rol})</option>)}
                  </select>
                </div>
                <div className="form-group">
                  <label>2. Denetçi</label>
                  <select value={form.denetleyen_2} onChange={e=>setForm({...form,denetleyen_2:e.target.value})}>
                    <option value="">Seçin...</option>
                    {personeller.map(p=><option key={p.id} value={p.id}>{p.ad_soyad} ({p.rol})</option>)}
                  </select>
                </div>
                <div className="form-group" style={{gridColumn:'1/-1'}}><label>Açıklama</label><textarea value={form.aciklama} onChange={e=>setForm({...form,aciklama:e.target.value})} rows={2}/></div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={()=>setModalAcik(false)}>İptal</button>
                <button type="submit" className="btn btn-primary">Kaydet</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Sonuç modal */}
      {secili&&(
        <div className="modal-overlay" onClick={e=>e.target===e.currentTarget&&setSecili(null)}>
          <div className="modal" style={{maxWidth:'500px'}}>
            <div className="modal-header"><span className="modal-title">Denetim Sonucu — {secili.denetim_no}</span><button className="modal-close" onClick={()=>setSecili(null)}>×</button></div>
            <form onSubmit={sonucKaydet}>
              <div className="form-grid">
                <div className="form-group">
                  <label>Durum *</label>
                  <select value={secili.durum} onChange={e=>setSecili({...secili,durum:e.target.value})} required>
                    {Object.keys(DURUM_RENK).map(k=><option key={k} value={k}>{k}</option>)}
                  </select>
                </div>
                <div className="form-group">
                  <label>Gerçekleşen Tarih</label>
                  <input type="date" value={secili.gerceklesen_tarih||''} onChange={e=>setSecili({...secili,gerceklesen_tarih:e.target.value})} />
                </div>
                <div className="form-group" style={{display:'flex',alignItems:'center',gap:'8px',paddingTop:'22px'}}>
                  <input type="checkbox" id="yp" checked={!!secili.yaptirim_gerekli} onChange={e=>setSecili({...secili,yaptirim_gerekli:e.target.checked})} />
                  <label htmlFor="yp" style={{marginBottom:0,color:'#c62828',fontWeight:'600'}}>Yaptırım Gerekli</label>
                </div>
                <div className="form-group" style={{gridColumn:'1/-1'}}><label>Bulgular</label><textarea value={secili.bulgular||''} onChange={e=>setSecili({...secili,bulgular:e.target.value})} rows={3}/></div>
                <div className="form-group" style={{gridColumn:'1/-1'}}><label>Sonuç</label><textarea value={secili.sonuc||''} onChange={e=>setSecili({...secili,sonuc:e.target.value})} rows={2}/></div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={()=>setSecili(null)}>İptal</button>
                <button type="submit" className="btn btn-primary">Güncelle</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
